import * as React from 'react';
import Badge from '@telia-front/badge';
import EqualHeight from '@telia-front/equal-height';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import { ProcessListContext } from '../process-list/process-list';
const ProcessListItem = (props) => {
    const { headingLevel } = React.useContext(ProcessListContext);
    const { children, className, elementRef, icon, index, image, title, } = props;
    const BEM = () => {
        const classArray = ['process-list__item'];
        if (image) {
            classArray.push('process-list__item--with-image');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const transitionDelay = `${(index || 0) * 500}ms`;
    return (React.createElement("li", { className: BEM(), ref: elementRef },
        React.createElement("div", { className: "process-list__item-inner" },
            React.createElement("div", { className: "process-list__item-header" },
                React.createElement("div", { className: "process-list__item-header-inner", style: { transitionDelay } },
                    React.createElement(EqualHeight, { group: "process-list-icon" },
                        icon && React.createElement(Icon, { modifiers: icon, className: "process-list__icon" }),
                        image && React.createElement(Image, Object.assign({}, image, { className: "process-list__image" }))),
                    React.createElement(EqualHeight, { group: "process-list-title", className: "process-list__item-title-wrapper" },
                        React.createElement(Heading, { level: headingLevel, className: "process-list__item-title h4 text-bold" }, title))),
                React.createElement("div", { className: "process-list__badge-wrapper", style: { transitionDelay } },
                    React.createElement(Badge, { text: index !== undefined ? index + 1 : '', size: "large", purpose: "selected" }))),
            React.createElement("div", { className: "process-list__content", style: { transitionDelay } }, children))));
};
export default ProcessListItem;
